/* global fbq, ga */
import h from 'react-hyperscript';
import { Router, Route, browserHistory} from 'react-router';
import Contact from '../Contact';
import Course from '../Course';
import CourseSuccess from '../CourseSuccess';
import Landing from '../Landing';
import Admin from '../Admin';
import Login from '../Login';
import Universities from '../Universities';
import ApplicationForm from '../ApplicationForm';
import Payment from '../Payment';
import HtmlAndCssRoute from '../HtmlAndCssRoute';
import JavascriptCourseRoute from '../JavascriptCourseRoute';
import ContactSuccess from '../ContactSuccess';
import PaymentSuccess from '../PaymentSuccess';
import About from '../About';
import FAQ from '../FAQ';

const handleUpdateRoute = function() {
  const currentPath = this.state.routes[0].path;
  if (window.fbq) {
    fbq('track', 'ViewContent', { content_name: currentPath });
  }
  if (window.ga) {
    ga('send', 'pageview', { page: currentPath });
  }
};

const Routes = () => {
    return (
        h(Router, {onUpdate: handleUpdateRoute, history: browserHistory}, [
            h(Route, {path: '/', component: Landing}),
            h(Route, {path: '/admin', component: Admin}),
            h(Route, {path: '/login', component: Login}),
            h(Route, {path: '/universities', component: Universities}),
            h(Route, {path: '/html-and-css', component: HtmlAndCssRoute}),
            h(Route, {path: '/javascript', component: JavascriptCourseRoute}),
            h(Route, {path: '/faqs', component: FAQ}),
            h(Route, {path: '/about', component: About}),
            h(Route, {path: '/testlist', component: ApplicationForm}),
            h(Route, {path: '/course/:id', component: Course}),
            h(Route, {path: '/course/:submissionId/success', component: CourseSuccess}),
            h(Route, {path: '/contact', component: Contact}),
            h(Route, {path: '/contact/success', component: ContactSuccess}),
            h(Route, {path: '/payment/:id', component: Payment}),
            h(Route, {path: '/payment/:id/success', component: PaymentSuccess})
        ])
    );
};

export default Routes;



/** WEBPACK FOOTER **
 ** ./src/Routes/index.js
 **/